<template>
  <div class="animated fadeIn">

    <div class="container bmw-cockpit">
      <div class="row">
        <div class="col-xl">
          <div ref="cockpit-and-filter" class="card">
            <div class="card-header" >
              <div class="form-row">
                <div class="form-group col-md-2">
                  <treeselect :placeholder="$t('Webportal.BrandFilter.Placeholder')"
                              ref="brandTreeselect"
                              instance-id="Brand"
                              v-model="selection.Brand"
                              :options="optionsdata.Brand"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :max-height="600"
                              :searchable="true"
                              :clearable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="false"
                              value-consists-of="LEAF_PRIORITY"
                              showCountOf="LEAF_DESCENDANTS"
                              search-nested
                              :disabled="isLoading"
                              @open="handleOpenBrand"
                              @select="handleSelectBrand"
                              @deselect="handleDeselectBrand"
                              @close="handleCloseBrand"
                              @input="handleInputBrand"  />
                </div>

                <div class="form-group col-md-4">
                  <treeselect :placeholder="$t('Webportal.ScenarioFilter.Placeholder')"
                              ref="surveysTreeselect"
                              instance-id="Surveys"
                              v-model="selection.Surveys"
                              :options="optionsdata.Surveys"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="false"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="false"
                              value-consists-of="LEAF_PRIORITY"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!selection.Brand || isLoading" />
                </div>

                <div class="form-group col-md-3">
                  <treeselect :placeholder="$t('Webportal.WaveFilter.Placeholder')"
                              ref="waveTreeselect"
                              instance-id="Waves"
                              v-model="selection.Waves"
                              :options="optionsdata.Waves"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="(!autoFilter.isEnabled ? !selection.Brand : !isWaveFilterEnabled)  || isLoading" />
                </div>

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.RegionFilter.Placeholder')"
                              ref="regionsTreeselect"
                              instance-id="Regions"
                              v-model="selection.Regions"
                              :options="optionsdata.Regions"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="(!autoFilter.isEnabled ? !selection.Brand : !isRegionFilterEnabled) || isLoading" />
                </div>

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.SubregionFilter.Placeholder')"
                              ref="subregionTreeselect"
                              instance-id="Subregions"
                              v-model="selection.Subregions"
                              :options="optionsdata.Subregions"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="(!autoFilter.isEnabled ? !selection.Brand : !isSubregionFilterEnabled) || isLoading" />
                </div>

              </div>

              <div class="form-row">

                <div class="form-group col-md-2">
                  <treeselect :placeholder="$t('Webportal.DashboardBMW.NSCImporterFilter.Placeholder')"
                              ref="nscsTreeselect"
                              instance-id="NSCs"
                              v-model="selection.NSCs"
                              :options="optionsdata.NSCs"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="(!autoFilter.isEnabled ? !selection.Brand : !isNscFilterEnabled) || isLoading" />
                </div>

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.DashboardBMW.NSCSubregionFilter.Placeholder')"
                              ref="nscsubTreeselect"
                              instance-id="SubNSCs"
                              v-model="selection.SubNSCs"
                              :options="optionsdata.SubNSCs"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="(!autoFilter.isEnabled ? !selection.Brand : !isNscSubFilterEnabled) || isLoading" />
                </div>

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.AreaFilter.Placeholder')"
                              ref="areasTreeselect"
                              instance-id="Areas"
                              v-model="selection.Areas"
                              :options="optionsdata.Areas"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="(!autoFilter.isEnabled ? !selection.Brand : !isAreaFilterEnabled) || isLoading" />
                </div>

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.DashboardBMW.DealergroupFilter.Placeholder')"
                              ref="dealergroupsTreeselect"
                              instance-id="Dealergroups"
                              v-model="selection.Dealergroups"
                              :options="optionsdata.Dealergroups"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="(!autoFilter.isEnabled ? !selection.Brand : !isDealergroupFilterEnabled) || isLoading" />
                </div>

                <div class="form-group col-md-3">
                  <CustomTreeSelect :placeholder="$t('Webportal.DashboardBMW.OutletFilter.Placeholder')"
                              ref="outletsTreeselect"
                              instance-id="ClientLocations"
                              v-model="selection.ClientLocations"
                              :options="optionsdata.ClientLocations"
                              :multiple="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="(!autoFilter.isEnabled ? !selection.Brand : !isOutletsFilterEnabled) || isLoading">
                    <label  slot="option-label"
                            slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                            :class="labelClassName">
                      <span v-if="node.raw.isActive" v-b-tooltip.hover.nofade="toolTipDelay" :title="getLocationActiveText()">
                        <font-awesome-icon :icon="['far', 'lightbulb-on']" />
                      </span>
                      <span v-if="!node.raw.isActive" v-b-tooltip.hover.nofade="toolTipDelay" :title="getLocationInactiveText()">
                        <font-awesome-icon :icon="['far', 'lightbulb-slash']" />
                      </span>
                      {{ node.label }}
                    </label>
                  </CustomTreeSelect>
                </div>

                <div v-if="!isBmw2021" class="form-group col-md-2">
                  <treeselect :placeholder="$t('Webportal.DashboardBMW.ContactInitiationFilter.Placeholder')"
                              ref="contactinitiationTreeselect"
                              instance-id="WebsiteAnswers"
                              v-model="selection.WebsiteAnswers"
                              :options="optionsdata.WebsiteAnswers"
                              :auto-load-root-options="false"
                              :multiple="false"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isWebsiteAnswersEnabled" />
                </div>
              </div>

              <div class="form-row">
                <div class="col">
                  <div class="headinfos">
                    <h3 v-if="!isBmwMoto && !isGebrauchtwagen && !isUsedCar && !isUsedBike && !isBmw2020 && !isBmw2021">{{ $t('Webportal.DashboardBMW.HeadlineMysCarSalesPerformance') }}<br/></h3>
                    <h3 v-if="isBmw2021">MYSTERY SHOPPING SALES PERFORMANCE<br/></h3>
                    <h3 v-if="isBmw2020 && !isBmw2021">{{ $t('Webportal.DashboardBMW.HeadlineMysCarSalesPerformance') }}<br/>{{ $t('Webportal.DashboardBMW.NSC') }}: Q2 2020 ({{ $t('Webportal.Dashboard.KPIOVERVIEW') }})</h3>
                    <h3 v-if="isBmwMoto && !isBmw2021">{{ $t('Webportal.DashboardBMWMoto.SalesPerformance') }}<br/></h3>
                    <h3 v-if="isUsedBike">{{ $t('Webportal.DashboardBMWUsedBike.SalesPerformance') }}<br/></h3>
                    <div>
                      <h3 v-if="isGebrauchtwagen">{{ $t('Webportal.DashboardBMW.Gebrauchtwagen')}}<br/></h3>
                    </div>
                    <div>
                      <h3 v-if="isUsedCar">{{ $t('Webportal.Dashboard.UsedCarSalesPerformance')}}<br/></h3>
                    </div>
                  </div>
                </div>

                <!-- Enabled Switch for Autofilter-Button -->
                <div class="col-auto col-md-auto"  style="display: inherit;">
                  <label style="vertical-align: middle; margin-top: 0.5rem; margin-right: 0.25rem;" >
                    <div>
                      <span>{{ $t('Webportal.Dashboard.AutoFilter') }}</span>
                      <span v-b-tooltip.hover.nofade="toolTipDelay" :title="$t('Webportal.Dashboard.AutoFilter.Tooltip')">
                        <font-awesome-icon  :icon="['fas', 'info-circle']" />
                      </span>
                    </div>
                  </label>
                  <label class="switch switch-label switch-primary" style="margin-top: 0.4rem; margin-bottom: 0;">
                    <input  class="switch-input"
                            type="checkbox"
                            @change="autoFilterSwitchChanged"
                            v-model="autoFilter.isEnabled"
                            :disabled="isLoading || selection.Brand.length === 0 || selection.Surveys.length === 0">
                    <span class="switch-slider" data-checked="On" data-unchecked="Off"  v-b-tooltip.hover.nofade="toolTipDelay" :title="$t('Webportal.Dashboard.AutoFilter.ButtonTooltip')"></span>
                  </label>
                </div>
                <div class="col-auto"></div>

                <!-- Refresh-Button -->
                <div  class="col-auto col-md-auto"
                      :style="{ display: !autoFilter.isEnabled ? 'none' : 'inherit' }"
                      v-b-tooltip.hover.nofade="toolTipDelay"
                      :title="$t('Webportal.Dashboard.AutoFilter.ButtonTooltip')">
                  <button @click="invokeDashboardApi" 
                          class="btn btn-primary"
                          size="md"
                          style="width:8rem;"
                          :disabled="isRefreshDisabled">
                    <font-awesome-icon :icon="['fas', 'sync']" />&nbsp;&nbsp;{{ $t('Webportal.Dashboard.AutoFilter.ButtonText') }}
                  </button>
                </div>

                <div class="col-auto"></div>
                <div class="col-auto"></div>

                <!-- Screenshot-Button -->
                <div class="col-auto col-md-auto">
                  <exportelementbutton elementRef="cockpit" right
                                       :additionalElements="[{ Name: $t('Webportal.Dashboard.Export.IncludeFilter'),
                                                               ElementRef: 'cockpit-and-filter' }]"
                                       fileName="Cockpit"
                                       :disabled="showPlaceholder || isLoading" />
                </div>
              </div>
            </div>

            <div ref="cockpit" v-bind:class="{ spinner: isLoading || isLoadingModal, outdated: isOutdated && isRefreshDisabled }">
              <div class="card-body card-body-spacer">
                <dashboardpanel2021 v-if="isBmw2021 && !showPlaceholder && !isLoading && !isOutdated"
                                    :dashdata="dashdata"
                                    :selectedBrand="selection.Brand"
                                    :isBmwMoto="isBmwMoto"
                                    :isUsedBike="isUsedBike"
                                    :isBmwM="isBmwM"
                                    :isBmwi="isBmwi"
                                    :isUsedCar="isUsedCar"
                                    :isUsedCar2021="isUsedCar2021"
                                    :isGebrauchtwagen="isGebrauchtwagen"
                                    :selection="selection"
                                    :thresholds="thresholds"
                                    :thresholdSetting="thresholdSetting"
                                    :optionsdata="optionsdata"
                                    :yearsList="years"
                                    :activeYears="activeYears"
                                    :yearsbywave="yearsbywave">
                </dashboardpanel2021>

                <dashboardpanel v-if="!isBmw2021 && !isBmw2020 && !showPlaceholder && !isLoading && !isOutdated"
                                :dashdata="dashdata"
                                :selectedBrand="selection.Brand"
                                :isBmwMoto="isBmwMoto"
                                :isUsedBike="isUsedBike"
                                :isBmwM="isBmwM"
                                :isBmwi="isBmwi"
                                :isUsedCar="isUsedCar"
                                :isGebrauchtwagen="isGebrauchtwagen"
                                :selection="selection"
                                :optionsdata="optionsdata"
                                :yearsList="years"
                                :yearsbywave="yearsbywave">
                </dashboardpanel>

                <dashboardpanel2020 v-if="!isBmw2021 && isBmw2020 && !showPlaceholder && !isLoading && !isOutdated"
                                :dashdata="dashdata"
                                :selectedBrand="selection.Brand"
                                :isBmwMoto="isBmwMoto"
                                :isUsedBike="isUsedBike"
                                :isBmwM="isBmwM"
                                :isBmwi="isBmwi"
                                :isUsedCar="isUsedCar"
                                :isGebrauchtwagen="isGebrauchtwagen"
                                :selection="selection"
                                :optionsdata="optionsdata"
                                :yearsList="years"
                                :yearsbywave="yearsbywave">
                </dashboardpanel2020>

                <div class="emptyplacehold" v-if="showPlaceholder && !isLoading">
                  {{ $t('Webportal.DashboardBMW.NoDataFound')}}
                </div>

                <div class="emptyplacehold" v-if="isLoading">
                  {{ $t('Webportal.Dashboard.Loading')}}
                </div>

                <!-- Refresh-Button -->
                <div  v-if="isOutdated && !isLoading" 
                      :class="{ outdated: isLoading }">
                  <div  class="col-auto col-md-auto text-center">
                    <button @click="invokeDashboardApi" 
                            v-b-tooltip.hover.nofade="toolTipDelay" 
                            style="width:8rem; margin-top: 10rem; margin-bottom: 10rem;"
                            :title="$t('Webportal.Dashboard.AutoFilter.ButtonTooltip')"
                            class="btn btn-primary" size="md"
                            :disabled="autoFilter.isEnabled || isLoading || selection.Brand.length === 0 || selection.Surveys.length === 0">
                      <font-awesome-icon :icon="['fas', 'sync']" />&nbsp;&nbsp;{{ $t('Webportal.Dashboard.AutoFilter.ButtonText') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="modalTooMuchWaves" id="modal-center" centered :title="$t('Webportal.Dashboard.Dialog.MaxWaves.Title')">
      <p class="my-4">{{ $t('Webportal.Dashboard.Dialog.MaxWaves.Text') }}</p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click="closeInfoDialog">
          {{ $t('Webportal.Dashboard.Ok') }}
        </b-btn>
      </div>
    </b-modal>
    
    <b-modal ref="modalQuestions" id="modal-center" scrollable size="lg" :title="kpiQuestionTitle()">
      <kpi-questions-dialog :data="modalQuestions.data"  />
      <div slot="modal-footer" class="w-100" style="display: none;">
        <!-- <b-btn size="sm" class="float-right" variant="primary" @click="closeInfoDialog">
          {{ $t('Webportal.Dashboard.Ok') }}
        </b-btn> -->
      </div>
    </b-modal>
  </div>

</template>


<script>
  import ActiveInactiveTexts from '@/mixins/ActiveInactiveTexts';
  import axios from 'axios';
  import BrandMixin from '@/mixins/BrandMixin';
  import CustomSelectorBrands from '@/mixins/bmw/customselectorbrands';
  import CustomSelectorWaves from '@/mixins/bmw/customselectorwaves';
  import DashboardPageMixin from '@/mixins/bmw/DashboardPage';
  import ThresholdColorMixin from '@/mixins/bmw/ThresholdColor';
  import dashboardpanel from '@/components/Dashboard-bmw/DashboardPanel'
  import dashboardpanel2020 from '@/components/Dashboard-bmw/DashboardPanel2020'
  import dashboardpanel2021 from '@/components/Dashboard-bmw/DashboardPanel2021'
  import DashboardService from '@/services/DashboardService-APP_TARGET'
  import EventBus from '@/services/EventBus.js'
  import CustomTreeSelect from '@/components/Shared/CustomTreeSelect';
  import exportelementbutton from './ExportElementButton'
  import KpiQuestionsDialog from '@/components/Dashboard-bmw/KpiQuestions/KpiQuestionsDialog.vue';
  import LocalizationChangedWithFilter from '@/mixins/LocalizationChangedWithFilter';

  export default {
    name: "Dashboard",

    mixins: [ ActiveInactiveTexts, BrandMixin,
      CustomSelectorBrands, CustomSelectorWaves, DashboardPageMixin,
      LocalizationChangedWithFilter, ThresholdColorMixin ],

    components: {
      CustomTreeSelect,
      dashboardpanel,
      dashboardpanel2020,
      dashboardpanel2021,
      exportelementbutton,
      KpiQuestionsDialog
    },

    data() {
      return {
        thresholdSetting: {
          selected: 'corporate',
          options: [
            { text: 'BMW AG', value: 'corporate', disabled: true },
            { text: 'Dealer', value: 'dealer', disabled: true }
          ]
        },
        modalQuestions: {
          kpi: null,
          data: null
        },
        kpiQuestionsCancelToken: null,
        isLoadingModal: false
      }
    },

    mounted(){
      this.getOptions('mounted');
      EventBus.$on('LocalizationChanged', this.localizationChanged);
      EventBus.$on('Modal-Kpi-Questions', this.handleModalKpiQuestions);
    },

    beforeDestroy() {
      EventBus.$off('LocalizationChanged', this.localizationChanged);
      EventBus.$off('Modal-Kpi-Questions', this.handleModalKpiQuestions);
    },

    methods: {
      kpiQuestionTitle() {
        return !this.modalQuestions.kpi ? "" : this.modalQuestions.kpi.KpiName;
      },

      getKpiQuestion() {
        var fltr = this.filterProperty(this);
        fltr.kpiCodes = [this.modalQuestions.kpi.KpiGroupCode, this.modalQuestions.kpi.KpiCode].filter(Boolean).join("^");

        // If the item is a kpi group then its group code is stored in property KpiCode and therefore KpiGroupCode is null.
        const isKpiGroup = this.modalQuestions.kpi.KpiGroupCode == null;

        this.modalQuestions.data = null;

        // Cancel previous request
        if (this.kpiQuestionsCancelToken) 
          this.kpiQuestionsCancelToken.cancel();
        this.kpiQuestionsCancelToken = axios.CancelToken.source()
        
        return DashboardService.getKpiQuestions(fltr, this.cockpitCancelToken)
          .then(response => {
            this.modalQuestions.data = { 
              ... response.data,
              KpiItem: isKpiGroup ? response.data?.KpiGroups?.[0] : response.data?.Kpis?.[0],
            };
          })
      },

      // e = { visible: true/false, kpi: kpi }
      handleModalKpiQuestions(e) {
        const modal = this.$refs.modalQuestions;

        if (e.visible)
        {
          this.modalQuestions.kpi = e.kpi;
          this.isLoadingModal = true;
          this.getKpiQuestion()
            .then(_ => modal.show())
            .finally(_ => this.isLoadingModal = false);
        }
        else 
          modal.hide();
      },

      getOverallItem: function (name) {
        var _this = this
        if (_this.dashdata && _this.dashdata.Overall && _.size(_this.dashdata.Overall) > 0)
          return _.findLast(_this.dashdata.Overall, (x) => x)
      },

      // Get survey structure data for the structure treeselect
      getDashboard(_this) {
        _this.setIsLoading(true);
        _this.isOutdated = false;

        var fltr = _this.filterProperty(_this);
        // Cancel previous request
        if (_this.cockpitCancelToken) _this.cockpitCancelToken.cancel();
        _this.cockpitCancelToken = axios.CancelToken.source()

        DashboardService.getDashboard(fltr, _this.cockpitCancelToken)
          .then(response => {
            _this.dashdata = _this.trimKpiNames(response.data);
            _this.isBmwMoto = this.getIsBmwMoto(_this.selection.Brand);
            _this.isBmwM = this.getIsBMWM(_this.selection.Brand);
            _this.isBmwi = this.getIsBMWi(_this.selection.Brand);
            _this.isGebrauchtwagen = this.getIsGebrauchtwagen(_this.selection.Brand);
            _this.isUsedCar = this.getIsUsedCar(_this.selection.Brand);
            _this.isUsedBike = this.getIsUsedBike(_this.selection.Brand);
            _this.isBmw2020 = this.getIsBmw2020(response.data, _this);
            _this.isUsedCar2021 = this.getIsUsedCar2021(_this.selection.Brand);
            _this.setIsLoading(false);
            })
          .catch((thrown) => {
            _this.setIsLoading(false);
          });
      },

      setOptions(_this, sender, opt) {
        _this.settingOptions = true;

        // initially select first item or if children exist, only BMW and MINI
        _this.selectBrands(_this.selection, opt);
        
        _this.filterSurveys(_this, opt);
        _this.selectSurveys(_this.selection, opt);
        
        // // Wenn keine Survey selektiert
        // if (this.autoFilter.isEnabled && _this.selection.Surveys.length === 0) {
        //   // Default: Alle 2019er Wellen selektieren
        //   // special logic - If "BMW Used Bike" is selected only one survey is allowed
        //   if (!this.getIsUsedBike(_this.selection.Brand))
        //   {
        //     opt.Surveys.forEach(survey => {
        //       if (contextYear === 2019) {
        //         if (survey.year === 2019) {
        //           _this.selection.Surveys.push(survey.id);
        //         }
        //       } else if (contextYear === 2020) {
        //         if (survey.year === 2020) {
        //           _this.selection.Surveys.push(survey.id);
        //         }
        //       }
        //     });
        //   };
        //   // Wenn es keine 2019er Surveys gibt, dann die alte Variante (erster in der Liste)
        //   if (_this.selection.Surveys.length === 0) {
        //     _.filter(opt.Surveys, function(s) {
        //       if(s.year >= 2021) {
        //         _this.selection.Surveys.push(s.id);
        //       }
        //     });
        //   }
        // } else {
        //   // autoFilter is disabled
        //   if (_this.selection.Surveys.length === 0) {
        //     _this.selection.Surveys = opt.Surveys[0].children.map(x => x.id);
        //   }
        // }
        this.initializeWaves(_this, sender, opt, null);

        // if only one option exists, ensure it is selected
        // opt.XYZ[0].ClientLocationCount === opt.XYZ[0].TotalClientLocationCount ... prevents an auto-select for
        // not fully filled datasets
        if (this.autoFilter.isEnabled)
          this.ensureOptionsAreSetWhenSingleOptionExists(opt, _this.selection);

        this.setOutlets(opt);

        _this.optionsdata = opt;
        _this.settingOptions = false;
      },

      // Used from shared method: filterProperty; in case of this component, inject a property value
      applyApiLayerToFilterProperty(filterProps) {
        if (!filterProps)
          filterProps = {};

        if (this.isBmw2021)
          filterProps.api = '2021';
        else
          filterProps.api = null;

        return filterProps;
      },

      getOverallItem: function (name) {
        var _this = this
        if (_this.dashdata && _this.dashdata.Overall && _.size(_this.dashdata.Overall) > 0)
          return _.findLast(_this.dashdata.Overall, (x) => x)
      }
    },

    computed: {
      thresholds: function() {
        // TODO: API für das BMW-Dashboard nicht verfügbar. Migrieren? Wie?
        if (!this.isBmwMoto) {
          return this.thresholdConfig;
        } else {
          return this.motorradDefaultThreshold();
        }
      },

      activeYears() {
        return !this.dashdata || !this.dashdata.OverallByWave || this.dashdata.OverallByWave.length < 1
          ? []
          : [...new Set(this.dashdata.OverallByWave[0].SurveyWave.map(x => x.Year))].sort((a, b) => a - b);
      }
    }
  }

</script>

<style lang="scss" scoped>
  @use "@/../scss/bmw/dashboardStyles.scss";
</style>
